





import { Vue, Component, Mixins } from "vue-property-decorator";
import _ from "lodash";

require("echarts-amap");

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins() {
  pointSimplifierIns!: any;

  option: any = {
    amap: {
      center: [104.114129, 37.550339],
      zoom: 4,
      mapStyle: "darkblue"
    },
    tooltip: {
      trigger: "item"
    },
    series: [
      {
        name: "网点数",
        data: [],
        type: "scatter",
        coordinateSystem: "amap",
        rippleEffect: {
          brushType: "stroke"
        },
        label: {
          // normal: {
            show: false,
            position: "right",
            formmater: "{b}"
          // }
        },
        itemStyle: {
          // normal: {
            color: "#f44336"
          // }
        }
      }
    ]
  };

  ei: any = {};

  async loadData() {
    const res1 = await this.$store.dispatch("statistics/getWholeStadiumMap", {});
    // console.log(res1.Data)
    if (res1 && res1.Data) {
      const data1: any[] = [];
      for (const k in res1.Data) {
        if (res1.Data[k]) {
          data1.push({
            name: res1.Data[k].name,
            position: res1.Data[k].value.split(",")
          });
        }
      }
      //   console.log('222')
      //   console.log(window.pointSimplifierIns)
      //   console.log(window)
      //   console.log(data1)
      this.pointSimplifierIns.setData(data1);

      // window.pointSimplifierIns.on('pointClick pointMouseover pointMouseout', (e: any, record: any) => {

      // })
    }
  }

  mounted() {
    // @ts-ignore
    const ei: any = this.$refs.ei.chart;
    const map: any = ei
      .getModel()
      .getComponent("amap")
      .getAMap();
    window.AMap.plugin(["AMap.ToolBar", "AMap.Scale", "AMap.OverView"], () => {
      map.addControl(new window.AMap.ToolBar());
      map.addControl(new window.AMap.Scale());
      map.addControl(new window.AMap.OverView({ isOpen: true }));
    });

    window.AMapUI.loadUI(["misc/PointSimplifier"], (PointSimplifier: any) => {
      if (!PointSimplifier.supportCanvas) {
        alert("当前环境不支持 Canvas!");
        return;
      }

      // 创建组件实例
      const pointSimplifierIns = new PointSimplifier({
        map, // 关联的map
        compareDataItem: (a: any, b: any, aIndex: number, bIndex: number) =>
          // 数据源中靠后的元素优先，index大的排到前面去
          aIndex > bIndex ? -1 : 1,
        getPosition: (dataItem: any) =>
          // 返回数据项的经纬度，AMap.LngLat实例或者经纬度数组
          dataItem.position,
        getHoverTitle: (dataItem: any, idx: number) =>
          // 返回数据项的Title信息，鼠标hover时显示

          dataItem.name,
        renderOptions: {
          // 点的样式
          pointStyle: {
            fillStyle: "blue" // 蓝色填充
          }
        }
      });

      this.pointSimplifierIns = pointSimplifierIns;
      //   console.log('1')
      this.loadData();
    });
  }
}
